import customsAccountBookApi from "@/api/CustomsAccountBookApi";

const CustomsAccountBookStore = {
  namespaced: true,
  state: {
    accountBookList: [],
  },
  mutations: {
    setAccountBookList(state, data) {
      state.accountBookList = data;
    },
  },
  actions: {
    listAll(ctx, data) {
      const searchCondition = {
        request: {
          pageInfo: {
            pageIndex: 1,
            pageSize: 1000,
          },
        },
      };

      customsAccountBookApi.listAccountList(searchCondition).then((res) => {
        ctx.commit(
          "setAccountBookList",
          res.items.map((item) => ({
            label: item.accountBookNo,
            value: item.accountBookNo,
          }))
        );
      });
    },
    bindOrUpdate(ctx, data) {
      return customsAccountBookApi.bindOrUpdate(data);
    },

    listAccountList(ctx, data) {
      return customsAccountBookApi.listAccountList(data);
    },

    adjustStock(ctx, data) {
      return customsAccountBookApi.adjustStock(data);
    },

    adjustStockPageQuery(ctx, data) {
      return customsAccountBookApi.adjustStockPageQuery(data);
    },
  },
};

export default CustomsAccountBookStore;
